/**
 * List all possible tasks the system is capable of processing.
 */
export enum CommunicationsRequestName {
  conferenceEnd = 'conferenceEnd',
  conferenceParticipantCreate = 'conferenceParticipantCreate',
  conferenceParticipantUpdate = 'conferenceParticipantUpdate',
  createAsyncServiceRequest = 'createAsyncServiceRequest',
  createOutboundCallSession = 'createOutboundCallSession',
  dialAsyncServiceRequest = 'dialAsyncServiceRequest',
  dialConference = 'dialConference',
  dialPhone = 'dialPhone',
  getCallLogPII = 'getCallLogPII',
  getConferenceParticipants = 'getConferenceParticipants',
  getConversationLogPII = 'getConversationLogPII',
  getSessionId = 'getSessionId',
  getVoiceDeviceToken = 'getVoiceDeviceToken',
  handleAsyncServiceRequest = 'handleAsyncServiceRequest',
  onTaskRouterConfigurationUpdated = 'onTaskRouterConfigurationUpdated',
  onVrcAudioUpdate = 'onVrcAudioUpdate',
}

export type CommunicationsRequestNameType = keyof typeof CommunicationsRequestName;
